'use client';

import React, {createContext, ReactNode, useContext, useMemo, useState} from 'react';
import {AuthContextType, UserProfile} from '@/types';

export enum Auth {
    initial,
    unverified,
    authenticated,
    unAuthenticated,
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({children}: { children: ReactNode }) => {
    const [profile, setProfile] = useState<UserProfile | null>(null);

    const signup = async (username: string, email: string, password: string) => {
        return await fetch('api/auth/signup', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({username, email, password}),
        });
    }


    const subCredits = (credits: number) => {
        setProfile((prev) => prev ? {...prev, credits: prev.credits - credits} : null);
    };

    const updateCredits = (credits: number) => {
        setProfile((prev) => prev ? {...prev, credits} : null);
    };


    const value = useMemo(() => ({
        signup,
        profile,
        subCredits,
        updateCredits,
    }), [profile]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};